import { createClient } from '@wallyhealth/web-core'
import config from 'config'

const marketingClient = createClient({
  baseUrl: config.MARKETING_KAPI_URL,
  timeout: 30000
})

const patientClient = createClient({
  baseUrl: config.PATIENT_KAPI_URL
})

export const fetchExperiment = ({ externalId }) => {
  return marketingClient.get(`/experiments/external/${externalId}`)
    .then(response => response.data)
}

export const prepSubscription = ({ patient, planPublicId, location, welcomeMessageId, tasks }) => {
  const body = {
    patient,
    locationId: location.id,
    geoId: location.geoId,
    planPublicId,
    welcomeMessageId,
    tasks
  }
  return patientClient.post('/billing/subscriptions/prep', body)
    .then(response => response.data)
}
